<!--
录音中动态圆圈 -->
<template>
  <div class="container">
    <div class="pulse"></div>
    <div class="pulse1"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {},
  mounted() {},
  watch: {}
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
// 圆圈css过程
@keyframes warn
  0%
    transform scale(0.9)
    -webkit-transform scale(0.9)
    opacity 0
  75%
    transform scale(0.9)
    -webkit-transform scale(0.9)
    opacity 0.8
  100%
    transform scale(1)
    -webkit-transform scale(1)
    opacity 0
@keyframes warn1
  0%
    transform scale(0.9)
    -webkit-transform scale(0.9)
    opacity 0
  75%
    transform scale(1)
    -webkit-transform scale(1)
    opacity 0.8
  100%
    transform scale(1.1)
    -webkit-transform scale(1.1)
    opacity 0
.container
  position relative
  width 90px
  height 90px
/* 产生动画（向外扩散变大）的圆圈 第一个圆 */
.pulse
  position absolute
  left -6px;/*no*/
  top -6px;/*no*/
  transform translate(-50%,-50%);/*no*/
  width 90px
  height 90px
  border 6px solid
  -webkit-border-radius 50%
  -moz-border-radius 50%
  border-radius 50%
  z-index 1
  opacity 0
  -webkit-animation warn 2s ease-out
  -moz-animation warn 2s ease-out
  animation warn 2s ease-out
  -webkit-animation-iteration-count infinite
  -moz-animation-iteration-count infinite
  animation-iteration-count infinite
  box-shadow 2px 2px 30px/* 阴影效果 */
/* 产生动画（向外扩散变大）的圆圈 第二个圆 */
.pulse1
  position absolute
  left -6px;/*no*/
  top -6px;/*no*/
  transform translate(-50%,-50%);/*no*/
  width 90px
  height 90px
  border 6px solid
  -webkit-border-radius 50%
  -moz-border-radius 50%
  border-radius 50%
  z-index 1
  opacity 0
  -webkit-animation warn1 2s ease-out
  -moz-animation warn1 2s ease-out
  animation warn1 2s ease-out
  -webkit-animation-iteration-count infinite
  -moz-animation-iteration-count infinite
  animation-iteration-count infinite
  box-shadow 2px 2px 30px /* 阴影效果 */
</style>
